import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

const INTERNAL_ROLES = new Set(["CEO", "Sales", "Analyst"]);

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="grain min-h-screen flex items-center justify-center">
        <Loader2 className="w-7 h-7 text-sky-400 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowed = roles && roles.length > 0 ? new Set(roles) : INTERNAL_ROLES;
  if (!allowed.has(user.role)) {
    return (
      <div className="grain min-h-screen flex items-center justify-center">
        <div className="max-w-md mx-auto p-8 border border-rose-500/30 bg-[var(--bg-secondary)]">
          <div className="tick-label text-rose-400 mb-2">/ Access Denied</div>
          <h1 className="font-display font-black text-xl text-slate-100 mb-3">
            Your account is not authorized.
          </h1>
          <p className="text-sm text-slate-400">
            Role <span className="font-mono text-sky-300">{user.role}</span> cannot access this area.
            If you should have access, contact the CEO to be promoted.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
